import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'
import KeyboardArrowLeftIcon from 'material-ui-icons/KeyboardArrowLeft'
import classNames from 'classnames'

const styles = theme => ({
  Container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
})

const FlowHeader = ({classes, back, title, close, containerClass}) => (
  <div className={classNames(classes.Container, containerClass)}>
    <IconButton onClick={back.show ? back.onClick : () => {}} style={{opacity: back.show ? 1 : 0}}>
      <KeyboardArrowLeftIcon/>
    </IconButton>
    <Typography variant={'body2'} color={'textSecondary'}>{title}</Typography>
    <IconButton onClick={close.show ? close.onClick : () => {}} style={{opacity: close.show ? 1 : 0}}>
      <CloseIcon/>
    </IconButton>
  </div>
)

FlowHeader.propTypes = {
  back: PropTypes.shape({
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
  title: PropTypes.string,
  close: PropTypes.shape({
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
  containerClass: PropTypes.string,
}

FlowHeader.defaultProps = {
  back: {
    show: false,
    onClick: () => {},
  },
  title: '',
  close: {
    show: false,
    onClick: () => {},
  },
}

export default withStyles(styles, {withTheme: true})(FlowHeader)



// WEBPACK FOOTER //
// ./src/sections/flow/components/flowHeader.jsx